document.addEventListener('DOMContentLoaded', () => {
  function navigateOrderLookUp(orderId) {
    const storeMap = {
      uss: 'us.anovaculinary.com/pages/order-lookup',
      cas: 'ca.anovaculinary.com/pages/order-lookup',
      uks: 'uk.anovaculinary.com/pages/order-lookup',
      eus: 'eu.anovaculinary.com/pages/order-lookup',
      ses: 'se.anovaculinary.com/pages/order-lookup',
      aus: 'au.anovaculinary.com/pages/order-lookup',
      nzs: 'nz.anovaculinary.com/pages/order-lookup',
      krs: 'kr.anovaculinary.com/pages/order-lookup',
      jps: 'jp.anovaculinary.com/pages/order-lookup',
      hks: 'hk.anovaculinary.com/pages/order-lookup',
      tws: 'tw.anovaculinary.com/pages/order-lookup',
      sgs: 'sg.anovaculinary.com/pages/order-lookup',
      ie: 'ie.anovaculinary.com/pages/order-lookup',
      ius: 'america.anovaculinary.com/pages/order-lookup',
      ies: 'europe.anovaculinary.com/pages/order-lookup',
      ias: 'asia.anovaculinary.com/pages/order-lookup',
      teams: 'team.anovaculinary.com/pages/order-lookup',
      usm: 'shop.anovaculinary.com/order-lookup',
      cam: 'shop.anovaculinary.com/order-lookup',
      ukm: 'shop.anovaculinary.com/order-lookup',
      eum: 'shop.anovaculinary.com/order-lookup',
      sem: 'shop.anovaculinary.com/order-lookup',
      aum: 'shop.anovaculinary.com/order-lookup',
      nzm: 'shop.anovaculinary.com/order-lookup',
      krm: 'shop.anovaculinary.com/order-lookup',
      jpm: 'shop.anovaculinary.com/order-lookup',
      hkm: 'shop.anovaculinary.com/order-lookup',
      twm: 'shop.anovaculinary.com/order-lookup',
      sgm: 'shop.anovaculinary.com/order-lookup',
      ium: 'shop.anovaculinary.com/order-lookup',
      iem: 'shop.anovaculinary.com/order-lookup',
      iam: 'shop.anovaculinary.com/order-lookup',
      team: 'shop.anovaculinary.com/order-lookup',
      us: 'shop.anovaculinary.com/order-lookup',
      ca: 'shop.anovaculinary.com/order-lookup',
      uk: 'shop.anovaculinary.com/order-lookup',
      eu: 'shop.anovaculinary.com/order-lookup',
      se: 'shop.anovaculinary.com/order-lookup',
      au: 'shop.anovaculinary.com/order-lookup',
      nz: 'shop.anovaculinary.com/order-lookup',
      kr: 'shop.anovaculinary.com/order-lookup',
      jp: 'shop.anovaculinary.com/order-lookup',
      hk: 'shop.anovaculinary.com/order-lookup',
      tw: 'shop.anovaculinary.com/order-lookup',
      mrkt: 'account.anovaculinary.com/orders',
    };

    var orderKeys = Object.keys(storeMap);
    var redirect = false;

    for (var i = 0; i < orderKeys.length; ++i) {
      if (orderId.includes(orderKeys[i])) {
        redirect = orderKeys[i];
        break;
      }
    }

    if (redirect) {
      window.location = `https://${storeMap[redirect]}?order=${orderId}`;
    } else {
      $('#orderLookupMessage').removeClass('hidden');
    }
  }

  (function () {
    $('#order-lookup').submit(function (e) {
      var orderId = $(this).find('input[name=order_number]').val().toLowerCase();

      e.preventDefault();
      $('#orderLookupMessage').addClass('hidden');
      navigateOrderLookUp(orderId);
    });
  })();
});
